import { post, toJson, handleSerializedResponse } from 'api'
import { isCreateTokenResponseOk } from 'credit-cards/utils'

const extractValuesFromResponse = ({ CardLast4, ccToken, ExpDate, CardType, NickName, Name, Id }) => ({
    CardLast4,
    ccToken,
    ExpDate,
    CardType,
    NickName,
    Name,
    Id,
    CardProcessor: 'NUVEI',
})

export const fetchNuveiSessionToken = () =>
    post(`${GRS_API_URL}/api/v1/Card/GetSessionToken`, {
        merchantId: window.PAYMENT_SERVICE_MERCHANT_ID,
        merchantSiteId: window.PAYMENT_SERVICE_MERCHANT_SITE_ID,
    })
        .then(toJson)
        .then(handleSerializedResponse)
        .catch(error => {
            throw new Error(error.message)
        })

export const fetchNuveiCCToken = ({ Token, CardNumber, SessionToken, CustomerName }) =>
    post(`${GRS_API_URL}/api/v1/Card/CreateCCToken`, {
        Token,
        CardNumber,
        SessionToken,
        CustomerName,
    })
        .then(isCreateTokenResponseOk)
        .then(toJson)
        .then(handleSerializedResponse)
        .then(extractValuesFromResponse)
        .catch(error => {
            throw new Error(error.message)
        })
